module.exports = __webpack_public_path__ + "img/moonriver.e1a527ee.svg";